<template>
  <div class="flex flex-wrap">
    <div class="px-1 sm:px-2">
      <VueGoodShareFacebook
        class="text-sm sm:text-base"
        :page_url="url"
        title_social="Facebook"
        :quote="fbText"
        has_icon
      />
    </div>
    <div class="px-1 sm:px-2">
      <VueGoodShareTwitter
        class="text-sm sm:text-base"
        :page_url="url"
        title_social="Twitter"
        :page_title="twText"
        has_icon
      />
    </div>
    <div class="px-1 sm:px-2">
      <VueGoodShareLinkedIn
        class="text-sm sm:text-base"
        :page_url="url"
        title_social="LinkedIn"
        has_icon
      />
    </div>
  </div>
</template>

<script>
import VueGoodShareFacebook from 'vue-goodshare/src/providers/Facebook'
import VueGoodShareTwitter from 'vue-goodshare/src/providers/Twitter'
import VueGoodShareLinkedIn from 'vue-goodshare/src/providers/LinkedIn'

export default {
  components: {
    VueGoodShareFacebook,
    VueGoodShareTwitter,
    VueGoodShareLinkedIn,
  },

  props: {
    url: {
      type: String,
      required: true,
    },

    fbText: {
      type: String,
      required: true,
    },

    twText: {
      type: String,
      required: true,
    },
  },
}
</script>
